import { Box, Grid, styled, Typography } from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useRef, useState } from "react";

import { primary } from "../../../constants/theme";
import { imagesWEBP } from "../../../constants/webpImages";
import { Context } from "../../../context/context";
import { MemoizedButton } from "../../../SDK/button";
import { sendAnalytics } from "../../../utils/analyticsCommon";
import { MemoizedOTP } from "../../Otp/otp";
import UseConnectWithUs from "./useConnectWithUs";

const CustomConnectWithUs = styled(Box)(({ theme }) => ({
  margin: "20px",
  marginTop: "30px",
  padding: "20px",
  ".input-box .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl":
    {
      background: "rgba(255, 255, 255, 0.9)",
      borderRadius: "8px",
      width: "100% !important",
    },

  ".input-box": {
    width: "100%",
    //background: "white",
  },
  ".image-section": {
    objectFit: "contain",
    // width: "100% !important",
    position: "relative !important",
  },
}));

const ConnectWithUs = ({ popup, showForm, setShowForm, data }) => {
  const state = useContext(Context);
  const targetRef = useRef(null);
  const navigate = useRouter();

  const { form, loading } = UseConnectWithUs();
  const [isCheckedModal, setIsCheckedModal] = useState(true);

  const handleCheckboxChangeModal = () => {
    setIsCheckedModal(!isCheckedModal);
  };

  // function paytmPixelLead() {
  //   var myDiv = document.createElement("div");
  //   myDiv.setAttribute("id", "abc");
  //   var serverScript = document.createElement("script");
  //   serverScript.type = "text/javascript";
  //   serverScript.src =
  //     "https://evt.paytm.com/pixel/frontend/pixel-1P.js?token=E85D2514D1034AF1";
  //   myDiv.appendChild(serverScript);
  //   document.body.appendChild(myDiv);
  //   setTimeout(function () {
  //     document.getElementById("abc").remove();
  //   }, 2000);
  // }

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        const payload = { brandExpPath: navigate?.pathname };
        !popup && sendAnalytics("scroll_brand_form_fold", payload, "en");
      }
    }, options);

    if (targetRef.current) observer.observe(targetRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
    // eslint-disable-next-line
  }, [targetRef]);

  return (
    <CustomConnectWithUs
      style={{
        display: popup
          ? state?.showStoryFormValue === true
            ? "block"
            : "none"
          : "block",
        background: "linear-gradient(180deg, #D9D9D9 0%, #FFEDB7 100%)",
        marginTop: popup ? "0px" : "40px",
        margin: popup ? "0px" : "20px",
        borderRadius: "4px",
      }}
    >
      <Box
        id="brand-form"
        ref={targetRef}

        // style={{
        //   marginTop: popup ? "0px" : "30px",
        //   marginBottom: popup ? "0px" : "30px",
        //   padding: popup ? "0px" : "1em",
        // }}
      >
        <Box
          style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
          onClick={(e) => {
            // form.handleSubmit(e);

            sendAnalytics("brand_form_title_clicked", {}, "en");
          }}
        >
          <Image
            src={
              data?.image_url
                ? imagesWEBP?.[data?.image_url]
                : imagesWEBP?.homeZor_Grand
            }
            width="60"
            height={"60"}
            alt="Benefits with Turno"
            className={"image-section"}
            effect="opacity"
          />
          <Box style={{ marginTop: "10px", marginLeft: "8px" }}>
            <Typography
              style={{
                fontSize: data?.isKannada ? "20px" : "24px",
                fontWeight: data?.isKannada ? "520" : "700",
                display: "flex",
                alignItems: "center",
                display: "flex",
                // margin: "10px",
                // textAlign: "center",
              }}
            >
              {" "}
              {data?.heading ?? "Electric gadi book madalu"}
            </Typography>
            <Typography style={{ fontSize: "14px", fontWeight: "500" }}>
              {data?.subHeading ?? "namanu contact madi"}
            </Typography>
          </Box>
        </Box>
        {/* <Box>
          <Typography
            style={{
              fontSize: "20px",
              fontWeight: "700",
              margin: "10px",
              textAlign: "center",
            }}
          >
            {" "}
            Electric gadi book madalu
          </Typography>
        </Box>
        <Box>
          <Typography
            style={{
              fontSize: "16px",
              fontWeight: 400,
              margin: "10px",
              textAlign: "center",
            }}
          >
            Nammannu contact madi
          </Typography>
        </Box> */}
        <Box style={{ margin: popup ? "20px 0px" : "30px 0px" }}>
          <form onSubmit={form.handleSubmit} className="form-schedule">
            <Box
              sx={{
                mb: popup ? 0 : "1em",
                mt: popup ? 0 : "1em",
                display: "flex",
              }}
            >
              <Grid container spacing={1}>
                {/* <Grid item xs={6} sm={6} md={6}>
                  {" "}
                  <MemoizedNameField
                    style={{ borderRadius: "8px" }}
                    className="input-box"
                    name="name"
                    error={!!checkError("name", form)}
                    helperText={form.errors.name}
                    placeholder="Your Name"
                    value={form.values.name}
                    onChange={(e) => {
                      form.handleChange(e);
                    }}
                  />
                </Grid> */}
                <Grid item xs={12} sm={12} md={12}>
                  <MemoizedOTP
                    style={{ borderRadius: "8px", width: "100%" }}
                    checked={isCheckedModal}
                    input_type="whatsapp"
                    form={form}
                    className="otp-styles"
                    connect_type={state.connect_type}
                    type=""
                    // sx={{ width: "100%" }}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={12} md={12}>
                  <MemoizedSelectDropDown
                    className="input-dropdown"
                    sx={{
                      borderRadius: "8px",
                      background: "#ffffff !important",
                    }}
                    form={form}
                    id={"state"}
                    name="state"
                    required={true}
                    title={"Select State"}
                    value={form.values.state}
                    optionsData={StateOptions}
                    onChange={form.handleChange}
                    error={!!checkError("state", form)}
                    helperText={form.errors.state}
                  />
                </Grid> */}
              </Grid>
            </Box>

            <Box>
              {!state.showOtpModule ? (
                <Box
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "baseline",
                  }}
                  sx={{ mt: { xs: "12px", md: "24px" } }}
                >
                  <input
                    label="blogs-checkbox"
                    type="checkbox"
                    required={true}
                    checked={isCheckedModal}
                    onChange={handleCheckboxChangeModal}
                  />

                  <Typography style={{ fontSize: "12px" }}>
                    By continuing, you’re agreeing to our{" "}
                    <span style={{ color: "#5D5BC0" }}>
                      Customer terms of service, User terms of Service, and
                      Privacy policy.
                    </span>
                  </Typography>
                </Box>
              ) : (
                <Box>
                  <Typography className="otp-disclaimer-text">
                    OTP Verification enables us to secure your account and enrol
                    you into our promotional programs{" "}
                  </Typography>
                </Box>
              )}
            </Box>
            <Box className="button-lets-chat" sx={{ mb: "1em", mt: "1em" }}>
              <MemoizedButton
                id="lead-form"
                disabled={!isCheckedModal}
                type="submit"
                content={data?.ctaInfo ?? "Talk to our Turno expert"}
                loading={loading}
                // sx={{
                //   background: "#35BF68",
                //   boxShadow: "0px 4px 0px #177138",
                //   width: "100%",
                //   background: primary.main,
                //   boxShadow: "none",
                //   border: "2px solid #E8345E",
                //   borderRadius: "4px",
                //   padding: "12px 8px",
                //   fontSize: "16px",
                //   color: "white",
                //   "&:hover": {
                //     background: primary.main,
                //     border: "none",
                //     color: "white",
                //     boxShadow: "none",
                //   },
                // }}

                sx={{
                  width: "100%",
                  background: primary.main,
                  borderRadius: "4px",
                  padding: "12px 8px",
                  fontSize: "20px",
                  color: "white",
                  "&:hover": {
                    background: primary.main,
                    color: "white",
                  },
                }}
                handleClick={(e) => {
                  // paytmPixelLead();
                  // setShowForm(false);
                  form.handleSubmit(e);
                }}
              />

              {/* <MemoizedButton
                id="lead-form"
                disabled={!isCheckedModal}
                type="submit"
                content={"Book my EV consultation"}
                loading={loading}
                sx={{
                  width: "100%",
                  background: primary.main,
                  borderRadius: "4px",
                  padding: "12px 8px",
                  fontSize: "16px",
                  color: "white",
                  "&:hover": {
                    background: primary.main,
                    color: "white",
                  },
                }}
                handleClick={(e) => {
                  leadActions("CLICK_EV_CONSULTATION");
                  createCookieInHour("lead_trigger", "book_ev_consult_btn", 10);
                  form.handleSubmit(e);
                }}
              /> */}
            </Box>
          </form>
        </Box>
      </Box>
    </CustomConnectWithUs>
  );
};

export default ConnectWithUs;
